import { Col, Row, Spin, Menu, Dropdown, Input, Modal } from 'antd';
import classNames from 'classnames/bind';
import { useEffect, useState } from 'react';
import serviceAPI from '~/api/ServiceAPI';
import { SVGS } from '~/assets/assetsPath';
import ItemService from '~/components/ItemService';
import styles from './SpaFilter.module.scss';
import { logEvent } from 'firebase/analytics';
import { analytics } from '~/service/firebase';
import styled from 'styled-components';
import branchAPI from '~/api/BranchAPI';
import FormFilterPrice from '~/components/FormFilterPrice';
import { useNavigate } from 'react-router';
import config from '~/config';

const cx = classNames.bind(styles);
const { Search } = Input;

const SearchComponent = styled.div`
    width: 100%;
    .ant-input-search-with-button .ant-input-group .ant-input {
        height: 44px;
        background-color: #fff7fd;
    }
    .ant-input-search-button {
        height: 44px;
    }
    .ant-btn-primary {
        background: #311d4f;
    }
    @media screen and (max-width: 480px) {
        margin: 20px 10px;
        /* .ant-input-search .ant-input-group .ant-input-group-addon:last-child {
            left: -215px;
        } */
        .ant-input-search-with-button .ant-input-group .ant-input {
            height: 44px;
            background-color: #f6f6f6;
        }
        .ant-btn-primary {
            background: #f6f6f6;
            border-left: unset;
            border-color: #e2e2e2;
            padding-top: 10px;
        }
        .anticon svg {
            color: #797979;
            height: 25px;
            width: 25px;
        }
    }
`;

const SpaFilter = () => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);

    const filterBack = JSON.parse(localStorage.getItem('filterBack'));

    const [isSearch, setIsSearch] = useState(filterBack?.isBackFilter ? false : true);

    const [keySearch, setKeySearch] = useState(filterBack?.keySearch || '');

    const [isShowModalPrice, setIsShowModalPrice] = useState(false);

    const [rangePrice, setRangePrice] = useState({
        priceLow: '',
        priceHight: '',
    });

    const [listService, setListService] = useState([]);
    const [pagination, setPagination] = useState({
        page: 1,
        limit: 12,
        total_item: 0,
        total_page: 0,
    });

    const [filterOrder, setFilterOrder] = useState({
        title: 'Price increases gradually',
        value: 'ASC',
        type: 'price_deducted',
    });

    const [filterBranch, setFilterBranch] = useState('');

    // Get list Service
    const handleGetListService = async (list, page, orderBy, search, branch_id, range) => {
        try {
            console.log('Khiem inside get', orderBy);
            setIsLoading(true);
            let services = list;
            let final = [];
            const filterS = {
                title: !search
                    ? undefined
                    : {
                          $iLike: `%${search}%`,
                      },
                branch_id: branch_id ? branch_id : undefined,
                price_deducted:
                    !range?.priceLow && !range.priceHigh
                        ? undefined
                        : { $between: [range?.priceLow || 0, range?.priceHigh] },
            };
            const params = {
                fields: '["$all", {"unit": ["$all"]}]',
                filter: JSON.stringify(filterS),
                order: orderBy?.value ? `[["${orderBy?.type}", "${orderBy?.value}"]]` : null,
                limit: pagination.limit,
                service: search,
                page: page,
            };
            const res = await serviceAPI.getListServiceAPI(params);

            if (res.code === 200) {
                services.push(...res.results.objects.rows);
                setPagination({
                    ...pagination,
                    page: page,
                    total_item: res.results.objects.count,
                    total_page: Math.ceil(res.results.objects.count / res.pagination.limit),
                });
            }
            if (services?.length) {
                final = [...new Map(services.map((item) => [item['id'], item])).values()];
            }
            setListService([...final]);
            setIsLoading(false);
        } catch (err) {
            console.log(err);
        }
    };

    const handleChangeKeySearch = (e) => {
        const value = e.target.value;
        setKeySearch(value);
    };
    const onSearch = (e) => {
        setIsSearch(false);
        handleGetListService([], 1, filterOrder, keySearch, filterBranch, rangePrice);
    };

    const handleSetShowModalPrice = () => {
        setIsShowModalPrice(false);
    };

    const handleSeeMore = () => {
        try {
            const nextPage = pagination.page + 1;
            handleGetListService(listService, nextPage, filterOrder, keySearch, filterBranch, rangePrice);
        } catch (err) {
            console.log(err);
        }
    };
    const handleSelectFilterOrder = (item) => {
        setFilterOrder(item);
        handleGetListService([], 1, item, keySearch, filterBranch, rangePrice);
    };

    useEffect(() => {
        handleGetListService([], 1, filterOrder, keySearch, filterBranch, rangePrice);
        // eslint-disable-next-line
    }, [rangePrice]);
    useEffect(() => {
        const branch_id = localStorage.getItem('branch_id');
        const filter = JSON.parse(localStorage.getItem('filterBack'));
        handleGetListService(
            [],
            1,
            filter?.filterOrder ? filter?.filterOrder : filterOrder,
            filter?.keySearch ? filter?.keySearch : keySearch,
            branch_id,
            filter?.rangePrice ? filter?.rangePrice : rangePrice,
        );
        setFilterBranch(branch_id);
        setIsSearch(filter?.isBackFilter ? false : true);
        setKeySearch(filter?.keySearch || '');
        setRangePrice(
            filter?.rangePrice || {
                priceLow: '',
                priceHight: '',
            },
        );
        setFilterOrder(
            filter?.filterOrder || {
                title: 'Price increases gradually',
                value: 'ASC',
                type: 'price_deducted',
            },
        );
        localStorage.removeItem('branch_id');
        localStorage.removeItem('filterBack');
        document.body.classList.remove('time-picker-booking-custom');
        //eslint-disable-next-line
    }, []);
    useEffect(() => {
        logEvent(analytics, 'VBeauty_Web_TrangDanhSachDichVu');
        // eslint-disable-next-line
    }, []);

    const menuSort = (
        <Menu
            items={[
                {
                    label: (
                        <p
                            onClick={() =>
                                handleSelectFilterOrder({
                                    title: 'Price increases gradually',
                                    value: 'ASC',
                                    type: 'price_deducted',
                                })
                            }
                        >
                            Prices gradually increase
                        </p>
                    ),
                    key: '1',
                },
                {
                    label: (
                        <p
                            onClick={() =>
                                handleSelectFilterOrder({
                                    title: 'Price decreasing',
                                    value: 'DESC',
                                    type: 'price_deducted',
                                })
                            }
                        >
                            Prices gradually decrease
                        </p>
                    ),
                    key: '2',
                },
            ]}
        />
    );

    const renderServiceList = () => {
        return isLoading ? (
            <Row justify="center" className={cx('spin')}>
                <Spin />
            </Row>
        ) : (
            <>
                {listService?.length ? (
                    <>
                        <Row className={cx('container_service')}>
                            {listService?.map((item, index) => {
                                return (
                                    <Col xs={24} sm={12} lg={8} key={index}>
                                        <Row>
                                            <ItemService
                                                data={item}
                                                isBackFilter={true}
                                                keySearch={keySearch}
                                                rangePrice={rangePrice}
                                                filterOrder={filterOrder}
                                                filterBranch={filterBranch}
                                            />
                                        </Row>
                                    </Col>
                                );
                            })}
                        </Row>
                        {pagination?.page < pagination?.total_page && (
                            <Row justify="center" style={{ marginTop: '30px' }}>
                                <div className={cx('btn_see_more')} onClick={handleSeeMore}>
                                    see more
                                </div>
                            </Row>
                        )}
                    </>
                ) : (
                    <div className={cx('no_service')}>
                        <img src={SVGS.IconNoService} alt="" />
                        <span>No service yet</span>
                    </div>
                )}
            </>
        );
    };

    return (
        <>
            {/* MOBILE UI */}
            <div className={cx('service_mobile')}>
                <div className={cx('title_header')}>
                    {isSearch ? (
                        <Row className={cx('header_row_search')}>
                            <Col xs={2}>
                                <img
                                    src={SVGS.ImageChevronLeft}
                                    alt="icon chevron left"
                                    className={cx('btn_search')}
                                    onClick={() => {
                                        navigate(config.routes.spa);
                                    }}
                                />
                            </Col>

                            <Col xs={22}>
                                <Row className={cx('search')}>
                                    <SearchComponent>
                                        <Search
                                            placeholder="Search for services"
                                            value={keySearch}
                                            onChange={handleChangeKeySearch}
                                            onSearch={onSearch}
                                            enterButton
                                        />
                                    </SearchComponent>
                                </Row>
                            </Col>
                        </Row>
                    ) : (
                        <Row className={cx('header_row')}>
                            <Col>
                                <Row>
                                    <img
                                        src={SVGS.ImageChevronLeft}
                                        alt="icon chevron left"
                                        className={cx('btn_search')}
                                        onClick={() => {
                                            navigate(config.routes.spa);
                                        }}
                                    />

                                    <span className={cx('header_title')}>Service</span>
                                </Row>
                            </Col>
                            <Col>
                                <Row>
                                    <img
                                        src={SVGS.ImageSearch}
                                        alt="icon search"
                                        className={cx('btn_search')}
                                        onClick={() => {
                                            setIsSearch(true);
                                        }}
                                    />
                                </Row>
                            </Col>
                        </Row>
                    )}
                    {!isSearch && (
                        <Row className={cx('search_header')}>
                            <span className={cx('search_title')}>Search:</span>
                            <span className={cx('search_key')}>{keySearch}</span>
                        </Row>
                    )}
                    {!isSearch && (
                        <div className={cx('title_sort')}>
                            <div className={cx('right_section')}>
                                <Row className={cx('filter_mobile')} align="middle">
                                    <Row style={{ width: '100%' }}>
                                        <Dropdown overlay={menuSort} trigger={['click']}>
                                            <button onClick={(e) => e.preventDefault()} className={cx('button')}>
                                                <Row align="middle">
                                                    <Col xs={3}>
                                                        <Row>
                                                            <img src={SVGS.ImageSwitch} alt="" />
                                                        </Row>
                                                    </Col>
                                                    <Col xs={18}>
                                                        <Row className={cx('title_select')}>
                                                            <span>
                                                                {filterOrder.value ? filterOrder.title : 'Options'}
                                                            </span>
                                                        </Row>
                                                    </Col>
                                                    <Col xs={3}>
                                                        <Row justify="end">
                                                            <img src={SVGS.ImageChevronDown} alt="" />
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            </button>
                                        </Dropdown>
                                    </Row>
                                </Row>
                            </div>
                            <div
                                className={cx('sort_price')}
                                onClick={() => {
                                    setIsShowModalPrice(true);
                                }}
                            >
                                <img src={SVGS.ImageAdjustments} alt="" />
                                <span>Filter</span>
                            </div>
                        </div>
                    )}
                </div>
                {!isSearch ? (
                    <div className={cx('service_list_all')}>{renderServiceList()}</div>
                ) : (
                    <div className={cx('service_list_all')}> </div>
                )}
            </div>
            <Modal
                centered
                visible={isShowModalPrice}
                onCancel={() => setIsShowModalPrice(false)}
                maskClosable={false}
                footer={null}
                style={{ top: 230 }}
                className="otp-modal-price"
                width={500}
                destroyOnClose
            >
                <div style={{ padding: '0px 0px' }}>
                    <FormFilterPrice
                        title="Filter services"
                        isShowModalPrice={isShowModalPrice}
                        isCancel={handleSetShowModalPrice}
                        rangePrice={rangePrice}
                        setRangePrice={setRangePrice}
                    />
                </div>
            </Modal>
        </>
    );
};

export default SpaFilter;
